import { useMqrFilters } from 'hooks/useMqrFilters'
import { mqrApi } from 'redux/services/mqr'

import { AppStatistics } from 'components/AppStatistics/AppStatistics'

export function Statistics() {
  const { params } = useMqrFilters()

  const { data, isSuccess } = mqrApi.useMqrStatisticsQuery(params)

  if (isSuccess) {
    return <AppStatistics list={data} />
  }
  return null
}
